RivalIQ.apps.AdsInsights.module('views', function (views, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const MAX_TITLE_LENGTH = 150;
    const MAX_BODY_LENGTH = 150;
    const LOW_SPEND_WARNING_THRESHOLD = 0.02;


    function buildMetric(baseMetric, id) {
        const attrs = {};
        attrs[_.head(baseMetric.getFreeDimensions())] = id;

        return baseMetric.build(attrs);
    }

    function findSubmetric(submetrics, property, id) {
        const baseMetric = _.find(submetrics, function (submetric) {
            return submetric.get('property') === property;
        });

        if (baseMetric) {
            return buildMetric(baseMetric, id);
        }
    }

    const ShowLowSpendWarning = {
        showLowSpendWarning: function () {
            const me = this;

            const spendPctOfOverall = findSubmetric(me.model.submetrics, 'spend_pct_of_overall', _.head(me.getOption('data')))
                .getValue({
                    format: false
                });

            return _.isNumber(spendPctOfOverall) && spendPctOfOverall < LOW_SPEND_WARNING_THRESHOLD;
        }
    };


    views.AdObjectNameCell = Marionette.ItemView.mixin({
        tagName: 'td',

        // find an observation, if any, that pertains to this row.
        findRelevantObservation: function () {
            const me = this;
            const adObject = _.last(me.getOption('data'));
            if (me.dashboardModel.metricObservationsGenerator) {
                return me.dashboardModel.metricObservationsGenerator.findRelevantObservation(adObject.id);
            }
        },

        className: function () {
            const me = this;
            let className = 'name-cell ad-observation-callout ';

            if (me.dashboardModel.getProp('doubleHeight')) {
                className += ' double-height ';
            }

            const relevantObservation = me.findRelevantObservation();
            if (relevantObservation) {
                className += relevantObservation.observationClass;
            }

            return className;
        },
        template: '#adObjectCellTemplate',

        mixins: {
            showLowSpendWarning: ShowLowSpendWarning
        },

        templateHelpers: function () {
            const me = this;
            const adObject = _.last(me.getOption('data'));

            const params = _.extend(_.pick(me.dashboardModel.getProps(), App.utils.validCurationOptions), {
                adAccountId: adObject.adAccountId,
                adObjectId: adObject.id,
                exploreLevel: App.utils.childExploreLevel(adObject.adObjectType)
            });

            return _.extend({
                s: s,
                exploreObjectUrl: function () { // this is a fcn to accomdate search
                    return RivalIQ.apps.Dashboard.router.router.resolveCurationRoute(
                        RivalIQ.enums.curation.FACEBOOK_ADS_INSIGHTS,
                        params
                    );
                }
            }, RivalIQ.utils.emoji.getTemplateHelpers());
        },

        serializeData: function () {
            const me = this;
            const adObject = _.last(me.getOption('data'));

            const objective = RivalIQ.enums.facebookAdCampaignObjectives[adObject.objective];

            let statusPopover = null;

            if (adObject.effective_status) {
                const effectiveStatus = (adObject.effective_status ? adObject.effective_status.toLowerCase() : null);
                statusPopover = _.template('<div class="ad-status-popover">Status: <div class="ad-status status-<%- effectiveStatus %>"><i class="fa fa-circle"/></div> <%- statusName %></div>')({
                    effectiveStatus: effectiveStatus.toLowerCase(),
                    statusName: _.upperFirst(effectiveStatus.toLowerCase())
                });
            }

            return _.extend({
                creative: null,
                showExploreObjectUrl: !adObject.isBreakdown,
                effective_status: undefined,
                relevantObservation: me.findRelevantObservation(),
                statusPopover: statusPopover
            }, adObject, {
                maxTitleLength: MAX_TITLE_LENGTH,
                maxBodyLength: MAX_BODY_LENGTH,
                objective: objective,
                showLowSpendWarning: me.showLowSpendWarning(),
                name: adObject.name
            });
        }
    });

    views.AdsTableCell = RivalIQ.views.metric.Bar.extend({
        color: RivalIQ.enums.colors.progressBarBlue,
        template: '#adsTableBarCellTemplate',

        className: function () {
            const me = this;

            const modelIndex = me.model.collection.indexOf(me.model);

            const maxStringLength = me.getOption('table').labelBounds[modelIndex];

            const classNames = `metric-table-cell ads-bar-max-digits-${maxStringLength}`;

            return classNames;
        },

        serializeData: function () {
            const me = this;

            const viewData = RivalIQ.views.metric.Bar.prototype.serializeData.apply(me, arguments);

            let metricLabel = null;

            // if the metric is pointing at an underlying metric (e.g., results), show that underlying metrics'
            // name as a label.
            const data = me.getOption('data');
            const underlyingMetricProperty = _.get(_.last(data), ['propertyName']);
            if (underlyingMetricProperty) {
                const underlyingMetric = _.defaults({
                    property: underlyingMetricProperty
                }, me.model.attributes);
                metricLabel = RivalIQ.metric.names.metricName(underlyingMetric);
            }

            const noResultsReason = _.get(_.last(data), ['noResultsReason']);
            if (noResultsReason) {
                metricLabel = noResultsReason;
                viewData.value = '--';
            }

            return _.extend(viewData, {
                metricLabel: metricLabel
            });
        }
    });


    views.AdsTextTableCell = Marionette.ItemView.mixin({
        tagName: 'td',

        template: '#adsTableTextCellTemplate',

        serializeData: function () {
            const me = this;

            const data = me.getOption('data');
            const name = me.model.getName();
            const value = (_.last(data) === null ? '--' : _.last(data));
            const tooltip = Marionette.TemplateCache.get('#adsTableTextCellTooltip')({
                name: name,
                value: value
            });

            return {
                value: _.last(data),
                tooltip: tooltip,
                maxValueLength: MAX_BODY_LENGTH
            };
        },

        templateHelpers: function () {
            return _.extend({
                s: s
            }, RivalIQ.utils.emoji.getTemplateHelpers());
        }
    });

}, window.s);
